//Types
import { LanguageButtonProps } from "./types";
//Styles
import "./styles.scss";

function LanguageButton({ active, title, handleClick }: LanguageButtonProps) {
  const activeStyles = active ? "language-button__active" : "";

  return (
    <button
      aria-label={`language-toggler-${title}`}
      className={`language-button ${activeStyles}`}
      onClick={handleClick}
    >
      {title}
    </button>
  );
}

export default LanguageButton;
